//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "FooterToolBar"
};